/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_ValidationWarningDTO = {
    /**
     * AffectedEntity is the optional entity identifier
     */
    affected_entity?: string;
    /**
     * ChildID is the id of the child the warning is about (link target for the
     * child detail page). Empty when the warning has no resolvable child.
     */
    child_id?: string;
    /**
     * ChildInternalID is the organisation's internal child number
     */
    child_internal_id?: string;
    /**
     * ChildName is the child's full name
     */
    child_name?: string;
    /**
     * Code is the warning code constant
     */
    code?: string;
    /**
     * ContractID is the id of the contract VERSION the warning is about (link
     * target for the contract-version detail page). Empty when the warning is
     * not tied to a contract version.
     */
    contract_id?: string;
    /**
     * ContractNumber is the human-readable contract number
     */
    contract_number?: string;
    /**
     * Message is the human-readable warning message
     */
    message?: string;
    /**
     * SettlingInDraftInvoiceID / Number / Period name the stale draft invoice to
     * cancel. Set only on SETTLING_IN_STALE_DRAFT (#1697).
     */
    settling_in_draft_invoice_id?: string;
    settling_in_draft_invoice_number?: string;
    settling_in_draft_period?: string;
    /**
     * SettlingInFirstInvoicePeriod ("YYYY-MM") is the period to generate first.
     * Set only on SETTLING_IN_FIRST_PERIOD_MISSING (#1697).
     */
    settling_in_first_invoice_period?: string;
    /**
     * SettlingInMissingStep names the closure step(s) the open plan still lacks.
     * Set only on SETTLING_IN_NOT_CLOSED (#1697).
     */
    settling_in_missing_step?: billing_ValidationWarningDTO.settling_in_missing_step;
    /**
     * SettlingInPlanID is the settling-in plan the hold is about; link target
     * /settling-in/:id. Set only on SETTLING_IN_NOT_CLOSED (#1697).
     */
    settling_in_plan_id?: string;
    /**
     * Severity is the severity level (info/warning/critical)
     */
    severity?: billing_ValidationWarningDTO.severity;
};
export namespace billing_ValidationWarningDTO {
    /**
     * SettlingInMissingStep names the closure step(s) the open plan still lacks.
     * Set only on SETTLING_IN_NOT_CLOSED (#1697).
     */
    export enum settling_in_missing_step {
        COMPLETION = 'completion',
        SIGN_OFF = 'sign_off',
        BOTH = 'both',
    }
    /**
     * Severity is the severity level (info/warning/critical)
     */
    export enum severity {
        INFO = 'info',
        WARNING = 'warning',
        CRITICAL = 'critical',
    }
}

